// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_IAmij","rotate":"rotate_8anZ0","circle-rotate":"circle-rotate_FQ-Ru","round-rotate":"round-rotate_ZEQLA"};